<template>
  <div id="BtnEditData">
    <hr />
    <button class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت تغییرات</button>
    <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
  </div>
</template>
,
<script>
import router from '@/router'

export default {
  data() {
    return {
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      DataAddLogInformation: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'UserLogInformation/b_AddRow',
        Token: this.$session.get('Token'),
      },
    }
  },
  methods: {
    SaveDeta() {
      if (this.$ValidForm(this.$route.name)) {
        this.$SetLog(this.DataParanet, 0)
        if (this.$route.name == 'DetailTarifSematha') {
          this.DataAxiosUpdate.Action = 'TarifSematha' + '/' + this.$store.state.tblgrpid
        } else {
          if (this.$route.name.substring(0, 6) == 'Detail') {
            this.DataAxiosUpdate.Action = this.$route.name.substring(6)
          } else {
            this.DataAxiosUpdate.Action = this.$route.name
          }
        }

        var uploaders = document.getElementsByClassName('uploader')
        console.log("😎 ~ SaveDeta ~ uploaders.length:", uploaders.length)
        if (uploaders.length > 0) {
          this.DataAxiosUpdate.ArryfildValue = this.DataParanet
          Array.prototype.slice.call(uploaders).forEach((element) => {
            if (element.value != '') {
              var Datafield = element.id
              const formData = new FormData()
              formData.append('TblUserGrpId', this.$session.get('UserInfo').tblGrpId)
              formData.append('UseTableName', this.$route.name)
              formData.append('ColName', Datafield)
              formData.append('Image', element.files[0])
              var FormDataImg = { Action: '', ArryfildValue: '', Method: '' }
              FormDataImg.Action = 'UploadImg/index'
              FormDataImg.ArryfildValue = formData
              FormDataImg.Method = 'POST'
              this.$PostFormData(FormDataImg)
                .then((data) => {
                  if (data.status == 'OK') {
                    this.DataAxiosUpdate.ArryfildValue[Datafield] = data.imageId
                  } else {
                    this.$mySweetDefaultTost('خطا', 'خطا در بارگذاری فایل', 'error', 2000)
                  }
                })
                .finally(() => {
                  this.$PutData_Body(this.DataAxiosUpdate)
                    .then((data) => {
                      if (data.status == 'Ok') {
                        this.$emit('Success', true)
                        this.$mySweetDefaultTost(false, 'تغییرات اطلاعات با موفقیت انجام شد', 'success', 3000)
                        if (this.$route.name == 'DetailAlarm') {
                          var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'))
                          var temp = UserAlarm.indexOf(UserAlarm.filter((x) => x.Id == data.AlarmStatus.Id)[0])
                          UserAlarm.splice(temp, 1)
                          UserAlarm.push(data.AlarmStatus)
                          this.$cookies.set('UserAlarm', JSON.stringify(UserAlarm))
                        }
                        document.getElementById('btnCancel').click()
                      } else {
                        if (data.eNum == '2601') {
                          this.$mySweetDefaultTost(false, 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                        }
                      }
                    })
                    .finally(() => {
                      this.$store.state.renderComponentGrid = false
                      this.$store.state.renderComponent = false
                      this.$nextTick(() => {
                        this.$store.state.renderComponentGrid = true
                        this.$store.state.renderComponent = true
                      })
                    })
                })
            } else {
              this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                  if (data.status == 'Ok') {
                    this.$emit('Success', true)
                    this.$mySweetDefaultTost(false, 'تغییرات اطلاعات با موفقیت انجام شد', 'success', 3000)
                    if (this.$route.name == 'DetailAlarm') {
                      var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'))
                      var temp = UserAlarm.indexOf(UserAlarm.filter((x) => x.Id == data.AlarmStatus.Id)[0])
                      UserAlarm.splice(temp, 1)
                      UserAlarm.push(data.AlarmStatus)
                      this.$cookies.set('UserAlarm', JSON.stringify(UserAlarm))
                    }
                    if (this.$route.name == 'azainfo') {
                        this.$router.go(-1)
                      }
                    document.getElementById('btnCancel').click()
                  } else {
                    if (data.eNum == '2601') {
                      this.$mySweetDefaultTost(false, 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                    }
                  }
                })
                .finally(() => {
                  this.$store.state.renderComponentGrid = false
                  this.$store.state.renderComponent = false
                  this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                    this.$store.state.renderComponent = true
                  })
                })
            }
          })
        } else {
          this.DataAxiosUpdate.ArryfildValue = this.DataParanet
          this.$PutData_Body(this.DataAxiosUpdate)
            .then((data) => {
              if (data.status == 'Ok') {
                this.$mySweetDefaultTost(false, 'تغییرات اطلاعات با موفقیت انجام شد', 'success', 3000)
                this.$emit('Success', true)
                if (this.$route.name == 'DetailAlarm') {
                  var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'))
                  var temp = UserAlarm.indexOf(UserAlarm.filter((x) => x.Id == data.AlarmStatus.Id)[0])
                  UserAlarm.splice(temp, 1)
                  UserAlarm.push(data.AlarmStatus)
                  this.$cookies.set('UserAlarm', JSON.stringify(UserAlarm))
                }
                document.getElementById('btnCancel').click()
              } else {
                if (data.eNum == '2601') {
                  this.$mySweetDefaultTost(false, 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                }
              }
            })
            .finally(() => {
              this.$store.state.renderComponentGrid = false
              this.$store.state.renderComponent = false
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
                this.$store.state.renderComponent = true
              })
            })
        }
      }
    },
    Cancel() {
      if (this.ShowCancelButton == false) {
        this.$emit('Cancel', true)
      } else {
        this.$router.go(-1)
      }
    },
  },
  props: ['DataParanet', 'ShowCancelButton'],
}
</script>
<style scoped></style>
